// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import session from './session'
import { alert } from 'vue-strap'
import infiniteScroll from 'vue-infinite-scroll'
import vSelect from 'vue-select'
import VueAppInsights from 'vue-application-insights'

import axios from 'axios';
import getStringsForLocale from './resources/translations.js';
import applyAssignPolyfill from './shared/assignPolyfill.js';

applyAssignPolyfill();

Vue.use(infiniteScroll)
Vue.use(VueAppInsights, {
  id: process.env.APP_INSIGHTS,
  router
})
Vue.component('v-select', vSelect)

Vue.appInsights.queue.push(function () {
    Vue.appInsights.context.addTelemetryInitializer(function (envelope) {
        if (envelope.data != null && envelope.data.baseData != null
                && envelope.data.baseData.url != null 
                && envelope.data.baseData.url.indexOf("createPassword") != -1) {
            envelope.data.baseData.url = "/createPassword";
            envelope.data.baseData.name = "(Application Root)/createPassword";
        }
    });
});

export const globalStore = new Vue({
    data: {
        host: process.env.URL,
        digiUrl: process.env.DIGI_URL,
        envName: process.env.NODE_ENV,
        isInfoShown: false,
        message: '',
        type: '',
        culture: {
            locale: "EN",
            strings: getStringsForLocale("EN"),
            languages: [
                { code: "BG", countryCode: "BG", title: "Български" },
                { code: "DE", countryCode: "DE", title: "Deutsch" },
                { code: "EN", countryCode: "EN", title: "English" },
                { code: "ES", countryCode: "ES", title: "Español" },
                { code: "FR", countryCode: "FR", title: "Français" },
                { code: "IT", countryCode: "IT", title: "Italiano" },
                { code: "NL", countryCode: "NL", title: "Nederlands" },
                { code: "RU", countryCode: "RU", title: "Русский" },
                { code: "SL", countryCode: "SL", title: "Slovenščina" },
                { code: "PL", countryCode: "PL", title: "Polski" },
                { code: "CS", countryCode: "CZ", title: "Čeština" }
            ],
            getCountryCode(code) {
                for (var k = 0; k < globalStore.culture.languages.length; k++) {
                    if (globalStore.culture.languages[k].code === code) {
                        return globalStore.culture.languages[k].countryCode;
                    }
                }
            }
        },
        openedPoint: '',
        openedSubPoint: '',
        dashBoardDigiLinks: [
            { Group: "FOLBB_Digi", Url: "https://my.folbb.com", Title: "Prod" },
            { Group: "FOLBB_Digi_TEST", Url: "https://my-test.folbb.com", Title: "Test" }
        ],
        userListGroups: [],
        currentUserRoles: [],
        showInfo: function(event, message, type, timeout){
            if(event){
                event.preventDefault();
            }
            globalStore.type = `alert alert-` + type;
            globalStore.message = message;
            globalStore.isInfoShown = true;
			var infoTimeOut = 2500;
			if (!!timeout) {
				infoTimeOut = timeout;
			}
            setTimeout(() => (globalStore.isInfoShown = false), infoTimeOut);
        },
        showChangePassword: function(event, text, subText, router){
            if (this.openedSubPoint != subText){
                router.push('/dashboard/changePassword');
            }
            globalStore.openedPoint = text;
            globalStore.openedSubPoint = subText;
        },
        showUsersList: function(event, text, subText, router){
            //if (this.openedSubPoint != subText){
                router.push('/dashboard/userslist');
            //}
            globalStore.openedPoint = text;
            globalStore.openedSubPoint = subText;
        },
        isCurrentUserAdmin: false,
        currentUserDisplayName: '',
        checkRoles: function(){
            this.currentUserRoles = [];
            this.currentUserDisplayName = '';
            if(this.$session.exists()){
                var user = this.$session.get('user');
                if (user) {
                    globalStore.isCurrentUserAdmin = false;
                    if (user.Roles.indexOf('Administrator') > -1) {
                        globalStore.isCurrentUserAdmin = true;
                    }
                    this.currentUserRoles = user.Roles;
                    this.currentUserDisplayName = user.Name;
                }
            }     
        },
        currentUserAvatar: null,
        checkCurrentUserAvatar: function(){
            if(this.$session.exists()){
                var user = this.$session.get('user');
                if (user) {
                    if(user.Photo){
                        globalStore.currentUserAvatar = 'data:image/jpeg;base64,' + user.Photo;
                    }   else{
                        globalStore.currentUserAvatar = null;
                    }   
                }
            }
        },
        useCurrentUserLocale: function() {
            var lang = null;
            if(this.$session.exists()) {
                var user = this.$session.get('user');
                if (user) {
                    lang = user.PreferredLanguage;
                }
            } else {
                var nav = window.navigator;
                if (nav.userLanguage) {
                    lang = nav.userLanguage;
                } else if (nav.language) {
                    lang = nav.language;
                } else if (nav.systemLanguage) {
                    lang = nav.systemLanguage;
                }
            }
            if (lang == null) {
                lang = "EN";
            } else {
                try {
                    lang = lang.substring(0, 2).toUpperCase();
                } catch (exc) {
                    lang = "EN";
                }
            }

            

            globalStore.culture.locale = lang;
            globalStore.culture.strings = getStringsForLocale(lang);
        },
        isFiltersActive: false,
        strongRegex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{10,})"),
        mediumRegex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])"),
        weakRegex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])"),
        domainsBlackList: [
            '@ebg-virginfiber.com',
            '@folbb.com',
            '@folbb.net'
        ],
        emailInBlackList: function(email){
            var result = false;
            this.domainsBlackList.forEach(function(item) {
                if(email && email.toLowerCase().indexOf(item) > -1){
                    result = true;
                }
            });
            return result;
        },
        defaultTitle: 'FOLBB-ID',
        backLinkDomains: [
          '^(http(s)?\:\/\/)?(www\.)?ebg\-virginfiber\.com.*',
          '^(http(s)?\:\/\/)?(www\.)?folbb\.com.*',
          '^(http(s)?\:\/\/)?(www\.)?folbb\.net.*',
          '^(http(s)?\:\/\/)?(digi\.)?folbb\.com.*',
          '^(http(s)?\:\/\/)?(digi\-test\.)?folbb\.com.*',
          '^(http(s)?\:\/\/)?(my\.)?folbb\.com.*',
          '^(http(s)?\:\/\/)?(my\-test\.)?folbb\.com.*'
		],
		isBackLinkAllowed: function(lnk) {
			return this.backLinkDomains.some(function (itm) {
				var regEx = new RegExp(itm, "i");
				return regEx.test(lnk);
			});
        },
        isDigiUser: function(usr){
            var user = usr;
            if (user == null) {
                user = this.$session.get('user');
            }
            var groups = user.Groups;
            if (groups) {
              var hasSomeDigiGroup = this.dashBoardDigiLinks.some(function (itm) {
                 return groups.indexOf(itm.Group) > -1;
              });
              return hasSomeDigiGroup;
            }
            return false;
          }
    }
})

require('es6-promise').polyfill();
Vue.config.productionTip = false
Object.defineProperty(Vue.prototype, '$axios', {value: axios});

window.user = { IsLoggedIn : false }

/* eslint-disable no-new */


new Vue({
  el: '#app',
  router,
  session,
  axios,
  template: '<App />',
  components: { App, alert }
})

new Vue({
    el: '#head',
    router,
    session,
    components: {
        alert
    },
    data: {
        user: window.user,
        envName: globalStore.envName,
        version: '',
        languages: globalStore.culture.languages
    },
    methods: {
        changeCulture: function(lang) {
            globalStore.culture.locale = lang;
            globalStore.culture.strings = getStringsForLocale(lang);
        },
        showChangePassword: function(event, text, subText){
            event.preventDefault();
            globalStore.showChangePassword(event, text, subText, this.$router);
        },
        showUsersList: function(event, text, subText){
            event.preventDefault();
            globalStore.showUsersList(event, text, subText, this.$router);
        },
        createPassword: function(event) {
            event.preventDefault();
            this.$router.push('createPassword');
        },
        forgotPassword: function(event) {
            event.preventDefault();
            this.$router.push('forgotPassword');
        },
        logout: function() {
            this.$session.destroy()
            window.user.IsLoggedIn = false;
            this.$router.push('/login');
        },
        login: function() {
            this.$router.push('/login');
        },
        hideInfo: function(event) {
            event.preventDefault();
            globalStore.isInfoShown = false;
        },
        getCountryCode: function (code) {
          return globalStore.culture.getCountryCode(code);
        }
    },
    computed: {
        showInfo: function () {
            return globalStore.isInfoShown
        },
        message: function() {
            return globalStore.message
        },
        type: function() {
            return globalStore.type
        },
        actionText: function(){
            return this.labels.ACTION_TEXT;
        },
        changePasswordText: function(){
            return this.labels.CHANGE_PASSWORD_TEXT;
        },
        usersListText: function() {
            return this.labels.USERS_LIST_TEXT;
        },
        currentUserAvatar: function(){
            return globalStore.currentUserAvatar;
        },
        isCurrentUserAdmin: function(){
            return globalStore.isCurrentUserAdmin;
        },
        labels: function() {
            return globalStore.culture.strings.Header;
        },
        culture: function() {
            return globalStore.culture.locale;
        },
        currentUserRoles: function() {
            return globalStore.currentUserRoles;
        },
        currentUserDisplayName: function() {
            return globalStore.currentUserDisplayName;
        }
    },
    beforeCreate: function () {
        /*Vue.appInsights.queue.push(function () {
            Vue.appInsights.context.addTelemetryInitializer(function (envelope) {
                console.log(envelope.name);
                console.log(envelope.data.baseData.url);
                if (envelope.data != null && envelope.data.baseData != null
                        && envelope.data.baseData.url != null 
                        && envelope.data.baseData.url.indexOf("createPassword") != -1) {
                    console.log("hide URL")
                    envelope.data.baseData.url = "/createPassword";
                    envelope.data.baseData.name = "(Application Root)/createPassword";
                }
            });
        });*/

        window.user.IsLoggedIn = this.$session.exists();
        globalStore.checkRoles();
        globalStore.checkCurrentUserAvatar();
        globalStore.useCurrentUserLocale();
        //
        var self = this;
        self.$axios.get(globalStore.host + "Version")
            .then(response => {
                if (response.status === 200) {
                    self.version = 'v.' + response.data;
                }
            })
            .catch(err => {
                // ignore
            });

        
        self.$axios.get(globalStore.host + "GetPossibleRoles")
            .then(response => {
                if (response.status === 200) {
                    globalStore.userListGroups = response.data;
                }
            })
            .catch(err => {
                // ignore
            });
    }
})




// WEBPACK FOOTER //
// ./src/main.js